import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import supabase from '../../supabase'
import { Helmet } from 'react-helmet-async'
import whiteicon from '../../assets/manifestSVG.svg'

export default function Passrecovery() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const [successMessage, setSuccessMessage] = useState('')

  const handleResetRequest = async (e) => {
    e.preventDefault()
    setLoading(true)
    setErrorMsg('')
    setSuccessMessage('')

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/recovery`,
    })

    if (error) {
      setErrorMsg(error.message)
    } else {
      setSuccessMessage('Reset link sent! Check your inbox.')
    }
    setLoading(false)
  }

  return (
    <div className='min-h-screen w-full bg-[#f4f4f4] flex items-center justify-center pb-[60px] px-4 py-6 perspective-1000'>
      <Helmet>
        <title>Recovery | Sitemanifest</title>
      </Helmet>

      <div className='w-full lg:max-w-[900px] mt-[60px] lg:mt-[90px] max-w-[450px] bg-white rounded-2xl shadow-[0_40px_80px_rgba(0,0,0,0.12)] border border-gray-100 overflow-hidden flex flex-col lg:flex-row transform lg:rotate-y-[-4deg] lg:rotate-x-[2deg] transition-transform duration-700 hover:rotate-0'>
        
        <div className='hidden lg:flex lg:w-2/5 bg-[#1C6065] p-10 flex-col justify-between relative overflow-hidden'>
          <div className='absolute inset-0 z-0 opacity-[0.06] scale-150 transform translate-x-10 translate-y-10 select-none pointer-events-none'>
            <svg width="100%" height="100%" viewBox="0 0 800 800" fill="none">
              <circle cx="400" cy="400" r="380" stroke="#7CD998" strokeWidth="1"/>
              <ellipse cx="400" cy="400" rx="380" ry="140" stroke="#7CD998" strokeWidth="1"/>
              <ellipse cx="400" cy="400" rx="140" ry="380" stroke="#7CD998" strokeWidth="1"/>
            </svg>
          </div>
          <div className='relative z-10'>
            <div className='flex flex-row items-center gap-[14px]'>
              <img src={whiteicon} alt="" className="w-7 h-7 brightness-0 invert" />
              <h2 className='font-staat text-white text-2xl tracking-widest uppercase'>SITEMANIFEST</h2>
            </div>
            <div className='w-8 h-[2px] bg-[#7CD998] mt-1'></div>
          </div>
          <div className='relative z-10 bg-white/10 backdrop-blur-md border border-white/10 p-6 rounded-xl shadow-xl'>
            <p className='text-white font-poppins text-sm italic opacity-90'>"Finally a platform where trust is the core feature."</p>
          </div>
          <div className='w-8 h-1 rounded-full bg-white relative z-10'></div>
        </div>

        <div className='w-full lg:w-3/5 p-6 sm:p-10 flex flex-col justify-center bg-white'>
          <div className='mb-6'>
            <h1 className='text-2xl font-bold text-[#1C6065] tracking-tight'>Recover Password</h1>
            <p className='text-gray-400 text-[11px] mt-1'>
              Remember it? <button onClick={() => navigate('/signin')} className='text-[#1E7D6B] font-bold hover:underline'>Log in</button>
            </p>
          </div>

          {(errorMsg || successMessage) && (
            <div className="mb-4 animate-message">
              {errorMsg && <div className="p-3 rounded-xl bg-red-50 border border-red-100 text-red-600 text-[11px] font-bold">{errorMsg}</div>}
              {successMessage && <div className="p-3 rounded-xl bg-green-50 border border-green-100 text-[#1C6065] text-[11px] font-bold">{successMessage}</div>}
            </div>
          )}

          <form onSubmit={handleResetRequest} className='space-y-4'>
            <div className='space-y-1'>
              <label className='text-[9px] uppercase tracking-widest font-bold text-gray-400 ml-1'>Account Email</label>
              <input 
                type="email" 
                placeholder="email@address.com" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                required 
                className="w-full bg-gray-50 border border-gray-100 text-sm h-[46px] rounded-xl px-4 outline-none focus:bg-white focus:border-[#1E7D6B] transition-all" 
              />
            </div>

            <button 
              type="submit" 
              disabled={loading} 
              className="w-full bg-[#1C6065] h-[48px] rounded-xl font-bold text-sm text-white shadow-lg hover:bg-[#164d51] transition-all transform active:scale-[0.98] disabled:opacity-50"
            >
              {loading ? 'SENDING...' : 'SEND RESET LINK'}
            </button>
          </form>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        .perspective-1000 { perspective: 1200px; }
        .rotate-y-[-4deg] { transform: rotateY(-4deg) rotateX(2deg); }
        .animate-message { animation: slideIn 0.3s ease-out; }
        @keyframes slideIn { from { opacity: 0; transform: translateY(-5px); } to { opacity: 1; transform: translateY(0); } }
      `}} />
    </div>
  )
}